<template>
  <div styleName="opt_player_wrap" ref="player_t" :style="style" @mouseenter="mouseover" @mouseleave="mouseout" :data-switch="cssStyle">
    <div styleName="opt_toggle_fold" v-show="!isExpread && animationFinished">
      <span styleName="opt_toggle_fold_expread" @click="handelClickToggle" :data-role="isExpread">
      </span>
      <span styleName="opt_toggle_fold_icon">
      </span>
    </div>
    <transition name="scale" @after-leave="afterLeave">
      <div styleName="opt_toggle_expread opt_toggle_expread_active" v-show="isExpread" :data-switch="cssStyle">
        <span styleName="opt_toggle_fold_expread" @click="handelClickToggle" v-show="cssStyle==='normal'" :data-role="isExpread">
        </span>
        <CustomVideo @toggle="toggleExpread" />
      </div>
    </transition>
    <ToggleIcon :show="showToggle" @toggle="togglePlayerPPT" />
  </div>
</template>
<script>
import CSSModules from 'vue-css-modules'
import styles from './index.scss'
import ToggleIcon from '@/components/ToggleIcon'
import CustomVideo from './video'
import { mapGetters } from 'vuex'
import * as types from '@/constants/index'
import EleResize from '@/utils/divResize'
import { mediaSDK, signalSdk } from '@/utils/getSDK'

export default {
  mixins: [CSSModules(styles)],
  data: function () {
    return {
      isExpread: false, // 切换展开关闭状态
      showToggle: false,
      animationFinished: true
    }
  },
  components: {
    ToggleIcon, CustomVideo
  },
  computed: {
    ...mapGetters(['cssStyle', 'roomDetail', 'enterSignalRoom', 'pptSize']),
    style () {
      if (this.cssStyle === 'change') {
        return `position:absolute;top: ${this.pptSize.top}px;left: ${this.pptSize.left}px;
              width: ${this.pptSize.width}px; height: ${this.pptSize.height}px;`
      } else {
        let totalWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        return `position:absolute;right: -${320 - (totalWidth - this.pptSize.parentWidth)}px`
      }
    },
    isHasVideo () {
      return mediaSDK.getLocalStream() && mediaSDK.getLocalStream().video
    }
  },
  watch: {
    enterSignalRoom (val) {
      if (val) {
        signalSdk.sendSwitchVideoPPT('1')
        signalSdk.sendCloseVideoMessage()
      }
    },
    isExpread (val) {
      if (val) {
        this.animationFinished = false
      }
    },
    cssStyle (val) {
      if (val === 'normal' && !mediaSDK.getLocalStream().video) {
        let $t = setTimeout(() => {
          this.isExpread = false
          clearTimeout($t)
        }, 1000)
      }
    }
  },
  mounted () {
    EleResize.on(this.$refs.player_t, this.calcPlayerSize)
  },
  methods: {
    toggleIcon () {
      let { data } = this.roomDetail
      let { lessonSerialNumber } = data
      if (!lessonSerialNumber) {
        this.showToggle = !this.showToggle
      }
    },
    handelClickToggle () {
      this.isExpread = !this.isExpread
    },
    mouseover () {
      if (this.cssStyle === 'normal' &&
        this.isExpread &&
        this.isHasVideo) {
        this.showToggle = true
      }
    },
    mouseout () {
      this.showToggle = false
    },
    togglePlayerPPT () {
      signalSdk.sendSwitchVideoPPT('2').then(() => {
        this.$store.commit(types.TOGGLE_PLAYER_AND_PPT, 'change')
      })
    },
    toggleExpread (flag) {
      if (this.cssStyle === 'normal') this.isExpread = flag
    },
    afterLeave () {
      this.animationFinished = true
    },
    calcPlayerSize () {
      let { height } = this.$refs.player_t.getBoundingClientRect()
      if (this.cssStyle === 'change') height = 240
      this.$eventSource.emit('playerBoxChange', height)
    }
  }
}
</script>

<style>
.scale-enter-active,
.scale-leave-active {
  transition: all 0.5s ease;
}

.scale-enter,
.scale-leave-to {
  height: 42px;
}
</style>

